import { useState } from 'react'
import { legacyExcelMotivationOptions } from '../../mock/legacyExcelUpload'
import './LegacyExcelUpload.css'

type FieldKey = keyof typeof legacyExcelMotivationOptions

const fields: Array<{ key: FieldKey; label: string; copy?: boolean }> = [
  { key: 'group', label: '그룹' },
  { key: 'visitPath', label: '유입경로', copy: true },
  { key: 'hospital', label: '산부인과', copy: true },
  { key: 'postpartum', label: '조리원', copy: true },
]

const sourceRowIds: Partial<Record<FieldKey, string>> = { visitPath: 'l_row_visit1', hospital: 'l_row_visit2', postpartum: 'l_row_visit3' }

export function LegacyExcelMotivation() {
  const [openField, setOpenField] = useState<FieldKey | null>(null)
  const [values, setValues] = useState<Record<FieldKey, string>>(() => Object.fromEntries(fields.map(({ key }) => [key, legacyExcelMotivationOptions[key][0]])) as Record<FieldKey, string>)
  const [notice, setNotice] = useState('')

  const selectValue = (key: FieldKey, value: string) => {
    setValues((current) => ({ ...current, [key]: value }))
    setOpenField(null)
  }

  return <div className="legacy-c03-motivation-page">
    <h1 className="g_title l_save_title">방문동기 명칭 확인</h1>
    <section className="g_card legacy-c03-motivation-card">
      <select id="order_by_select" aria-hidden="true" tabIndex={-1} className="legacy-c03-hidden-select"><option>기본</option><option>이름순</option></select>
      <div className="l_select_container">
        {fields.map(({ key, label, copy }) => <div className="g_input_wrap" key={key}>
          <div className="g_row l_select_row" id={sourceRowIds[key]}>
            <span className="g_label title center">{label}</span>
            <div className={`l_row_content ${copy ? 'has-copy' : ''}`}>
              <select aria-hidden="true" tabIndex={-1} className="legacy-c03-hidden-select">{legacyExcelMotivationOptions[key].map((option) => <option key={option}>{option}</option>)}</select>
              <button className="chosen-container chosen-container-single" type="button" aria-haspopup="listbox" aria-expanded={openField === key} onClick={() => setOpenField((current) => current === key ? null : key)}>
                <span className="chosen-single"><span>{values[key]}</span><b /></span>
              </button>
              {openField === key && <div className="chosen-drop" role="listbox">{legacyExcelMotivationOptions[key].slice(0, 12).map((option) => <button type="button" role="option" aria-selected={option === values[key]} key={option} onClick={() => selectValue(key, option)}>{option}</button>)}</div>}
              {copy && <button className="g_item l_copy_name_btn" type="button" onClick={() => setNotice(`Mock ${label} 명칭을 복사했습니다.`)}>명칭복사</button>}
            </div>
          </div>
        </div>)}
      </div>
      <div className="g_text comment_box l_excel_guide">업로드 엑셀의 유입경로, 산부인과, 조리원을 선택할 때는 방문동기 명칭을 복사하여 사용하세요.</div>
      <div className="l_form_func"><div className="g_func_wrap"><button id="l_close_btn" className="g_btn" type="button" onClick={() => window.close()}>닫기</button></div></div>
    </section>
    {notice && <p className="legacy-c03-motivation-notice" role="status">{notice}</p>}
  </div>
}
